import store from '@/store';
import bus from '@/utils/mitt.js';
export function getToken() {
  const userInfo = store.state.userInfo;
  const isIfream = userInfo.isIfreamMode;
  const prefix = isIfream ? 'Copilot' : 'Bearer';
  const chatToken = isIfream ? userInfo.wwToken : userInfo.token;
  const Authorization = chatToken ? `${prefix} ${chatToken}` : '';
  return Authorization || '';
}
export const getMessageByCode = (code, errorMsg) => {
  let message = errorMsg;
  switch (code) {
    case 400:
      message = '很抱歉，出现了一些技术问题，请稍后重试。';
      break;
    case 401:
      message = '用户未登录，请先登录后再进行操作。';
      break;
    case 402:
      message = '很抱歉，您目前没有体验资格/体验次数已用尽，无法进行相关操作。';
      break;
    case 20004:
      message = '作为一个人工智能数字人，问题或答案超出了我的道德和法律规范，请换个问题';
      break;
    case 210007:
      message = '作为一个人工智能数字人，问题或答案超出了我的道德和法律规范，请换个问题';
      break;
  }
  if (message) {
    bus.emit('flvEnd', true);
    ElMessage({
      type: 'error',
      showClose: true,
      duration: 5000,
      message: message
    });
  }
};